import clsx from 'clsx'
import React from 'react'

import Navigation from '../Navigation/Navigation'
import DrawerDetailsApp from './DetailsApp/DrawerDetailsApp'
import DrawerEditApp from './EditApp/DrawerEditApp'
import DrawerHeader from './Header/DrawerHeader'
import DrawerNewApp from './NewApp/DrawerNewApp'
import DrawerNewSubApp from './NewSubApp/DrawerNewSubApp'

import { PortalContext } from '../../utils/PortalContext'

import styles from './drawer.module.css'

const Drawer = () => {
  const { openDrawer, drawerContent } = React.useContext(PortalContext)

  const drawerStyle = drawerContent === 'TabletMenu' ? styles.drawerLeft : styles.drawerRight
  const activeDrawerStyle = drawerContent === 'TabletMenu' ? styles.activeLeft : styles.activeRight

  return (
    <aside className={clsx(drawerStyle, { [activeDrawerStyle]: openDrawer })}>
      <DrawerHeader leftDrawer={drawerContent === 'TabletMenu'} />
      {drawerContent === 'NewApp' && <DrawerNewApp />}
      {drawerContent === 'DetailsApp' && <DrawerDetailsApp />}
      {drawerContent === 'NewSubApp' && <DrawerNewSubApp />}
      {drawerContent === 'EditApp' && <DrawerEditApp />}
      {drawerContent === 'TabletMenu' && <Navigation />}
    </aside>
  )
}

export default Drawer
